import * as React from 'react'

const SvgCloudUploadIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.875 11.25l.881.881 1.619-1.612v7.606h1.25v-7.606l1.619 1.612.881-.881L10 8.125 6.875 11.25zm7.813 2.5h-.313V12.5h.313a2.815 2.815 0 00.224-5.625h-.537l-.063-.513a4.375 4.375 0 00-8.675 0l-.012.513h-.537a2.815 2.815 0 00.224 5.625h.313v1.25h-.313A4.063 4.063 0 014.5 5.712a5.625 5.625 0 0111 0 4.063 4.063 0 01-.813 8.038z"
      fill="#163250"
    />
  </svg>
)

export default SvgCloudUploadIcon
